import { ScriptService } from './../../../../services/cms/script.service';
//Angular
import { Component, OnInit, ViewContainerRef,ChangeDetectionStrategy, ViewEncapsulation, Compiler, Inject, Renderer } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";

//Services
import { ClientAreaService } from "./../../../../services/settings/client-area.service";
import { LanguageService } from "./../../../../services/cms/language.service";
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { AuthService } from "./../../../../services/core/auth.service";
import { TemplateService } from "./../../../../services/settings/template.service";
import { SeoService } from "./../../../../services/core/seo.service";
import { MessagesService } from "../../../../services/core/messages.service";
import { RoutesService } from "../../../../services/core/routes.service";
import { CookieService } from "../../../../services/core/cookie/cookie.service";
import { BreadcrumbsService } from '../../../../services/cms/breadcrumbs.service';
import { TranslateService } from "@ngx-translate/core";

//Models
import { UserLogin } from "./../../../../models/cms/user-login";
import { ClientAreaOrderDetails } from "./../../../../models/settings/client-area";
import { ClientAreaOrderProcessMessages } from "./../../../../models/settings/client-area";
import { ClientAreaProcessingOrders } from "./../../../../models/settings/client-area";
import { ClientAreaOrderProcessFile } from "./../../../../models/settings/client-area";
import { CmsComponentService } from "./../../../../services/cms/cms-component.service";
//import * as moment from 'moment'
import { DomSanitizer, DOCUMENT } from "@angular/platform-browser";
import { Md5 } from 'ts-md5/dist/md5';
import { Breadcrumbs } from '../../../../models/cms/breadcrumbs';

import { Subscription } from 'rxjs/Subscription';
import { PaypalService } from "../../../../services/core/paypal.service";
import { Mappings } from "../../../../shared/mapping";
import { CurrencyService } from '../../../../services/cms/currency.service';

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    template: ""
})

export class ClientAreaOrderDetailsComponent implements OnInit {
    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            private templateService: TemplateService,
            private route: ActivatedRoute,
            private clientAreaService: ClientAreaService,
            private cmsComponentService: CmsComponentService,
            private authService: AuthService,
            private router: Router,
            @Inject('isBrowser') private isBrowser: boolean,
            private seo: SeoService,
            private renderer: Renderer,
            @Inject(DOCUMENT) private document: any
        ) { }

    orderId: number;
    clientArea: ClientAreaOrderDetails = new ClientAreaOrderDetails();

    subManager = new Subscription();

    ngOnInit() {
        if (!this.authService.GetData().isAuthenticated) {
            this.router.navigate([""]);
        }

        let subComponentTemplateUrl: string;
        let orderId: number = 0;
        let orderRowId: number = 0;

        let paramsSub = this.route.params.subscribe(params => {
            let templateHtml: string;
            let id = params['id'];
            let header: any;
            let headDataSub = this.cmsComponentService.getHeaderData().subscribe(result => {
                header = result;
                let SideMenuData = this.cmsComponentService.getSideMenuData().subscribe(result1 => {
                    if (result1.Categories) {
                        header.Categories = result1.Categories;
    
                    }
                });
                this.subManager.add(SideMenuData);
            });
            this.subManager.add(headDataSub);
            if (id !== undefined) {
                orderId = id;
                let UserId = this.authService.GetUserId();

                
                let orderIdSub = this.clientAreaService.getClientAreaOrderDetails(UserId, orderId).subscribe(result => {

                    templateHtml = result;
                    //Creating subcomponent whith the selected template to inject
                    let subComponent = this.createSubComponent(templateHtml, orderId,header);
                    //injecting created component (OK)
                    this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);

                });

                this.subManager.add(orderIdSub);
            }
            else {
                let orderNotFoundSub = this.templateService.getComponentTemplate("notfoundPageTemplate").subscribe(result => {
                    templateHtml = result;
                    //Creating subcomponent whith the selected template to inject
                    let subComponent = this.createSubComponent(templateHtml, orderId,header)
                    //injecting created component (OK)
                    this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
                });

                this.subManager.add(orderNotFoundSub);
            }
        });

        this.subManager.add(paramsSub);
    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    }

    private createSubComponent(template: any, orderId: number,header:any) {
        @Component({
            template: template.TemplateHtml
        })

        class ChildComponent implements OnInit {
            constructor
                (
                    private clientAreaService: ClientAreaService,
                    private languageService: LanguageService,
                    private authService: AuthService,
                    private routesService: RoutesService,
                    @Inject('CookieService') private cookie: CookieService,
                    private router: Router,
                    private activatedRoute: ActivatedRoute,
                    private sanitizer: DomSanitizer,
                    private messagesService: MessagesService,
                    @Inject('isBrowser') private isBrowser: boolean,
                    private seoService: SeoService,
                    public currency: CurrencyService,
                    private translateService: TranslateService,
                    private breadcrumbsService: BreadcrumbsService,
                    private paypalService: PaypalService,
                    private mappings: Mappings,
                    private scriptService: ScriptService
                ) { }

            private areaClientiHome: string[] = this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE');
            private areaClientiOrdini: string[] = this.routesService.getRoutePath('AREA CLIENTI - LISTA ORDINI');
            private areaChangeProfile: string[] = this.routesService.getRoutePath('AREA CLIENTI - DATI UTENTE - CAMBIO DATI PERSONALI');
            private areaClientiInvoices: string[] = this.routesService.getRoutePath('AREA CLIENTI - INVOICES');
            private areaClientiCatalogoRiservato: string[] = this.routesService.getRoutePath('RESERVED - CATALOG');
            private isActiveInvoicesModule: boolean = template.isActiveInvoicesModule;
            private isCatalogPrivateActive: boolean = template.isCatalogPrivateActive;
            model = {
                ProcessOrder: "",
                processingSubject: "",
                Description: ""
            };

            footerData: any = template.footerData;
            headerData: any = header;

            clientArea: ClientAreaOrderDetails = new ClientAreaOrderDetails();

            private clientAreaList: Array<ClientAreaOrderProcessFile> = new Array<ClientAreaOrderProcessFile>();
            private userLogin = UserLogin;
            private orderProcessMessageList: ClientAreaOrderProcessMessages[] = [];
            private message: ClientAreaProcessingOrders = new ClientAreaProcessingOrders();
            private lang: string = this.languageService.getLongLang();
            private authentication = this.authService.GetData();
            private userName = this.authentication.username;
            private userId = this.authService.GetUserId();
            private idord: ClientAreaProcessingOrders = new ClientAreaProcessingOrders();
            private upload: string = "";
            private info: string = "active";
            private comunicazioni: string = "";
            private paymentCompleteUrl: string;
            private criptedOrderID: any;
            private mdCripted: any;
            private noMessages: boolean = false;
            private checkValues: boolean = false;
            private waitingDetails: boolean = false;
            private pageIsInit: boolean = false;
            private pageIsAfterViewInit: boolean = false;
            private showSpinnerClick: boolean = false;

            //checking if multiple shipment module is active
            private multipleShipmentActive: boolean = template.isActiveMultipleShipment;
            private isTipologiaPagamentoBonifico = template.ClientAreaOrderDetails.isTipologiaPagamentoBonifico ? template.ClientAreaOrderDetails.isTipologiaPagamentoBonifico : false;
            private numeroTrnInvalid: boolean = false;
            private numeroCroInvalid: boolean = false;
            private startTrnValue: string = template.ClientAreaOrderDetails.BonificoTrn;
            private startCroValue: string = template.ClientAreaOrderDetails.BonificoCro;
            private bonificoUploadUrl = this.sanitizer.bypassSecurityTrustResourceUrl(template.BonificoUploadUrl);
            private bonificoUploadedFiles: string[] = template.ClientAreaOrderDetails.BonificoUploadedFilesNames;
            private breadcrumbs: Breadcrumbs[] = template.BreadcrumbsInfo;
            subManager = new Subscription();

            ngOnInit() {
                if (this.breadcrumbs != null) {
                    var len = this.breadcrumbs.length;
                    let nameLast = this.breadcrumbs[len - 1].BreadcrumbName;
                    let translatedName = this.translateTableColumnTitle(nameLast);
                    this.breadcrumbs[len - 1].BreadcrumbName = translatedName;
                }

                setTimeout(x => this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs), 1);

                this.waitingDetails = false;

                //if user from the page order list clicked on email
                let routeParamsSub = this.activatedRoute.params.subscribe((params: Params) => {
                    if (params["pagefrom"] == "section_upload") {
                        this.upload = "active";
                        this.info = "";
                        this.comunicazioni = "";
                    }
                    else if (params["pagefrom"] == "section_comunicazioni") {
                        this.comunicazioni = "active";
                        this.upload = "";
                        this.info = "";
                        let orderId = params["id"];
                        this.setMessagesAsRead(orderId)
                    }

                    this.waitingDetails = true;
                    this.clientArea = template.ClientAreaOrderDetails;

                    this.clientArea.CurrencyCode = "EUR";
                    let language = this.languageService.getShortLang();

                    //cripted orderID with Md5
                    this.criptedOrderID = Md5.hashStr(this.clientArea.OrderId.toString());

                    if (this.clientArea.OrderNoteList.length > 0) {
                        this.noMessages = false;
                    }
                    else {
                        this.noMessages = true;
                    }

                    //url that the user will be redirected to after paying of order via paypal
                    this.paymentCompleteUrl = this.clientArea.PaymentDoneUrl + this.criptedOrderID;
                    let paymentUrl = this.clientArea.PaymentDoneUrl + this.criptedOrderID;

                    this.paymentCompleteUrl = paymentUrl.replace('{lang}', language);
                    if (this.clientArea.NexiModel != null) {

                        if (this.clientArea.NexiModel.url_back_dettaglioOrdine != null) {
                            this.clientArea.NexiModel.url_back_dettaglioOrdine = this.clientArea.NexiModel.url_back_dettaglioOrdine.replace('{lang}', language);
                        }
                    }
                    //getting of link for upload files on order details page
                    for (let process of this.clientArea.ProcessingOrderList) {
                        process.FileUploadSecuredUrl = this.sanitizer.bypassSecurityTrustResourceUrl(process.FileUploadUrl);
                        process.PreflightUploadSecuredUrl = this.sanitizer.bypassSecurityTrustResourceUrl(process.PreflightUploadUrl);
                    }
                })

                this.subManager.add(routeParamsSub);

                if (this.clientArea.TrackingUrl != '' && this.clientArea.TrackingUrl != null) {
                    if (this.clientArea.TrackingUrl.indexOf("http://") == -1 && this.clientArea.TrackingUrl.indexOf("https://") == -1) {
                        this.clientArea.TrackingUrl = "http://" + this.clientArea.TrackingUrl;
                    }
                }

            }

            ngAfterViewChecked() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                //changing style of status bar(under detail order number) depending on multiple shipment module
                if (this.multipleShipmentActive == true) {
                    $("#paymentStatusBar").addClass('col-md-5').addClass('tabs-style').removeClass('col-md-3').removeClass('tabs-styleNoAfter');
                }
                else {
                    $("#paymentStatusBar").addClass('col-md-3').addClass('tabs-styleNoAfter').removeClass('col-md-5').removeClass('tabs-style');
                }

                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();

                this.pageIsInit = true;
            }

            ngAfterViewInit(): void {
                if (!this.isBrowser || this.pageIsAfterViewInit) {
                    return;
                }

                //-- If these conditions are not fulfilled, we are not gonna load paypal script, because there is no paypal payment option in the current order.
                if (this.clientArea.PaymentType == 'Paypal' && !this.isTipologiaPagamentoBonifico
                    && this.clientArea.PaymentStatus == 0 && this.clientArea.StrTotalBeforeTax != '0,00' && this.clientArea.IsNewPaypalIntegration) {
                    let userId = this.authService.GetUserId();
                    let params = {
                        CustomerId: userId.toString(),
                        OrderId: orderId.toString(),
                        Lang: this.lang,
                    };

                    //-- Load paypal service and render a button for paypal payment
                    this.paypalService.loadPaypalService(this.mappings.Paypal_JS_Lirary_Url,
                        this.mappings.Web_Api_Create_Paypal_Payment,
                        this.mappings.Web_Api_Execute_Paypal_Payment, params, this.clientArea.PaypalButtonStyle, this.clientArea.UsePaypalProduction);
                }

                this.pageIsAfterViewInit = true;
            }

            confirmBonificoDetails() {
                
                // trim value before sending it to a server
                this.clientArea.BonificoTrn = this.clientArea.BonificoTrn.trim();
             
                //showing of loading panel after we get all data we need
                this.routesService.showPageLoader();
                this.clientAreaService.updateBonificoPaymentDetails(orderId, this.clientArea.BonificoCro, this.clientArea.BonificoTrn)
                    .subscribe(x => {
                        this.startTrnValue = this.clientArea.BonificoTrn;
                        this.startCroValue = this.clientArea.BonificoCro;
                        //hiding of loading panel after we get all data we need
                        this.routesService.hidePageLoader();
                        this.hideBonificoModal();
                    },
                        err => {
                            this.clientArea.BonificoTrn = this.startTrnValue;
                            this.clientArea.BonificoCro = this.startCroValue;
                        });
            }

            // validate NumeroTrn input
            checkNumeroTrn(inputText: any) {
                inputText = inputText.trim();
                if (inputText.length < 31) {
                    this.numeroTrnInvalid = false;
                }
                else {
                    this.numeroTrnInvalid = true;
                }
            }

            // validate NumeroCro input
            checkNumeroCro(inputNumber: any) {
                if (inputNumber < 99999999999) {
                    this.numeroCroInvalid = false;
                }
                else {
                    this.numeroCroInvalid = true;
                }
            }

            // getting uploaded files for this order and showing it inside of bonifico modal
            getBonificoUploadedFiles() {
                //showing of loading panel after we get all data we need
                this.routesService.showPageLoader();
                this.clientAreaService.getBonificoUploadedFiles(orderId).subscribe(x => {
                    this.bonificoUploadedFiles = x;
                    //hiding of loading panel after we get all data we need
                    this.routesService.hidePageLoader();
                })
            }

            showBonificoModal() {
                $("#bonificoModal").modal("show");
            }

            hideBonificoModal() {
                $("#bonificoModal").modal("hide");

                this.clientArea.BonificoTrn = this.startTrnValue;
                this.clientArea.BonificoCro = this.startCroValue;
            }

            //translating of header columns titles
            translateTableColumnTitle(columnTitle) {
                let translation = this.translateService.get(columnTitle)["value"];
                return translation;
            }

            payWithPaypal() {
                let paypalText = "pay_with_paypal";
                let translatePaypal = this.translateService.get(paypalText)["value"];
                let formHtml = '<form ngNoForm action=\"' + this.clientArea.GatewayUrl + '\" method="post" target="_top" class="m0" name="paypalForm" id=\'paypalForm\'>' +
                    '<input type="hidden" name="cmd" value="_xclick">' +
                    '<input type="hidden" name="business"  value=\"' + this.clientArea.GatewayAccount + '\">' +
                    '<input type="hidden" name="item_name"  value=\"' + this.clientArea.OrderNumber + '\">' +
                    '<input type="hidden" name="currency_code" value=\"' + this.clientArea.CurrencyCode + '\">' +
                    '<input type="hidden" name="amount" value=\"' + this.clientArea.TotalCost + '\">' +
                    '<input type="hidden" name="item_number"  value=\"' + this.clientArea.OrderId + '\">' +
                    '<input type="hidden" name="return" value=\"' + this.paymentCompleteUrl + '\">' +
                    '<input type="hidden" name="rm" value="2">' +

                    '<button (click)="payWithPaypal()" class="btn btn-primary btn-lg" type="button" id="paypal-button-container" name="paypal-button-container">' +
                    '<i class="fa fa-credit-card"></i> ' + translatePaypal +
                    '</button>' +
                    '</form>';

                //replacing form with values from field because of security reasons - if somebody change html content
                let completePaypalForm = $("#completePaypalFormId").html(formHtml);

                $('#paypalForm').submit();
            }

            payWithNexi() {
                let NexiForm = $("#completeNexiFormId").html()
                let NexiText = "pay_with_nexi";
                let translateNexi = this.translateService.get(NexiText)["value"];
                let formHtml = '<form ngNoForm action=\"' + this.clientArea.NexiModel.requestUrl + '\" method="post" target="_top" class="m0" name="nexiForm" id=\'nexiForm\'>' +
                    '<input type="hidden" name="alias"  value=\"' + this.clientArea.NexiModel.alias + '\"/>' +
                    '<input type="hidden" name="importo"  value=\"' + this.clientArea.NexiModel.importo + '\"/>' +
                    '<input type="hidden" name="divisa"  value=\"' + this.clientArea.NexiModel.divisa + '\"/>' +
                    '<input type="hidden" name="codTrans" value=\"' + this.clientArea.NexiModel.codTrans + '\"/>' +
                    '<input type="hidden" name="url" value=\"' + this.clientArea.NexiModel.url + '\"/>' +
                    '<input type="hidden" name="url_back"  value=\"' + this.clientArea.NexiModel.url_back_ultimoStepCarrello + '\"/>' +
                    '<input type="hidden" name="mac" value=\"' + this.clientArea.NexiModel.mac + '\"/>' +
                    '<input type="hidden" name="tipo_servizio" value="paga_1click"/>' +
                    '<input type="hidden" name="num_contratto" value=\"' + this.clientArea.NexiModel.num_contratto + '\"/>';
                if (this.clientArea.NexiModel.gruppo != null && this.clientArea.NexiModel.gruppo != "") {
                    formHtml += '<input type="hidden" name="gruppo" value=\"' + this.clientArea.NexiModel.gruppo + '\"/>';
                }
                formHtml += '</form>' + NexiForm;
                // formHtml += '</form> <button (click)="payWithNexi()" class="btn btn-primary btn-lg w100" type="button" id="nexi-button-container" name="nexi-button-container">' +
                // '<i class="fa fa-credit-card"></i> ' + translateNexi +
                // '</button>';
                //replacing form with values from field because of security reasons - if somebody change html content
                let completeNexiForm = $("#completeNexiFormId").html(formHtml);

                $('#nexiForm').submit();
            }

            setMessagesAsRead(orderId) {
                let userId = this.authService.GetUserId();

                let params = {
                    CustomerId: userId.toString(),
                    OrderId: orderId.toString(),
                    Lang: this.lang
                };

                this.messagesService.setMessagesAsRead(params);
            }

            showModal() {
                $("#confirmModal").modal("show");
            }

            hideModal() {
                $('#confirmModal').modal('hide');
            }

            //Canceling of orders with status in coda
            cancelOrders() {
                let userId = this.userId;

                let cancelOrdSub = this.clientAreaService.cancelOrders(userId, orderId)
                    .subscribe(response => {
                        if (response == true) {
                            this.clientArea.Status = 4;
                        }
                    });

                this.subManager.add(cancelOrdSub);

                this.hideModal();
            }

            isDisabled(form) {
                let res: boolean = false;

                if (form.valid && this.model.ProcessOrder !== "") {
                    return true;
                }

                else {
                    return res;
                }
            }

            //sending of the message from the order details order
            processMessage() {
                this.showSpinnerClick=true;
                let postMessageSub = this.clientAreaService.postClientAreaSendProcessOrderMessageint(this.userId, orderId, parseInt(this.model.ProcessOrder), this.clientArea.OrderNumber, this.clientArea.UserCreated, this.model.processingSubject, this.model.Description, this.lang)
                    .subscribe(result => {
                        if(this.clientArea.OrderProcessMessageList==undefined||this.clientArea.OrderProcessMessageList==null)
                        {
                            this.clientArea.OrderProcessMessageList= [];
                        }
                        this.clientArea.OrderProcessMessageList.push
                            (
                                new ClientAreaOrderProcessMessages(), { "CreatedBy": this.clientArea.UserCreated, "StringDateCreated": result, "Description": this.model.Description, "From": 2, "Subject": this.model.processingSubject }
                            )

                        this.noMessages = false;
                        this.checkValues = false
                        this.model.ProcessOrder = "";
                        this.model.processingSubject = "";
                        this.model.Description = "";
                        this.showSpinnerClick=false;

                    });

                this.subManager.add(postMessageSub);
            }

            refreshProcessFiles(process) {
                let processFilesSub = this.clientAreaService.getProcessOrderFiles(process.Id, orderId).subscribe(result => {
                    result.ListOfFiles.forEach(element => {
                        if (element.Size.endsWith("byte")) {
                            element.Size = element.Size.substring(0, element.Size.length - 3);
                        }
                    });

                    process.FileState = result.FileState;
                    process.Files = result.ListOfFiles;
                });

                this.subManager.add(processFilesSub);
            }
            getClassforMenuClientArea()
            {
              let result;
              if(this.isActiveInvoicesModule&&this.isCatalogPrivateActive)
              {
                result="col-md-3 col-sm-3"
              }
              else if ((!this.isActiveInvoicesModule && this.isCatalogPrivateActive) || (this.isActiveInvoicesModule && !this.isCatalogPrivateActive)) {
                result = "col-md-3 col-sm-3"
              }
              else if (!this.isActiveInvoicesModule && !this.isCatalogPrivateActive) {
                result = "col-md-4 col-sm-4"
              }
              return result
            }
            ngOnDestroy() {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/settings/client-area/sys/client-area-order-details.component.ts